import SubPageUtils from '../../mixins/SubPageUtils';

import HeaderNav from '../../components/HeaderNav';
import Footer from '../../components/Footer';
import Headshot from '../../components/Headshot';
import Related from '../../components/Related';
import Discover from '../../components/Discover';

import ADA from './ADA';

export default {
  name: 'Participant',
  mixins: [SubPageUtils],
  components: { HeaderNav, Footer, Headshot, ADA, Related, Discover },
  data() {
    return {
      artist: null,
      allMediumsShowing: false,
      aboutShowing: false,
      artistsAtSameLocation: [],
      isFavorite: localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')).includes(this.$route.params.id) : false,
    };
  },
  computed: {
    aboutShort() {
      if (!this.artist.artist_statement) return '';
      let txt = this.artist.artist_statement.split('').splice(0, 152);
      if (txt[txt.length - 1] === ' ') txt.pop();
      return txt.join('');
    },
    titleFontSize() {
      let fontSize = 35;
      let name = this.artist.name;
      if (name.length > 14) fontSize = 28;
      if (name.length > 18) fontSize = 22;
      return fontSize;
    },
    hasA11y() {
      if (!this.artist.a11y_parking.includes('None of the above') || !this.artist.a11y_mobility.includes('None of the above') || !this.artist.a11y_restrooms.includes('None of the above') || !this.artist.a11y_other.includes('None of the above') || this.artist.a11y_family !== 'No') return true;
      return false;
    },
    artistBackground() {
      if (this.artist.artwork && this.artist.artwork.length > 0) {
        return this.artist.artwork[1] ? this.artist.artwork[1].images[0].image.url : this.artist.artwork[0].images[0].image.url;
      } else if (this.artist.headshot && this.artist.headshot.url && this.artist.headshot.url.length > 0) {
        return this.artist.headshot.url;
      }
      return '';
    },
  },
  methods: {
    favorite() {
      let artistID = this.artist.id;
      let favorites = JSON.parse(localStorage.getItem('favorites')) || [];

      if (favorites.indexOf(artistID) > -1) {
        // Unfavorite
        favorites.splice(favorites.indexOf(artistID), 1);
        this.isFavorite = false;
      } else {
        // Favorite
        favorites.push(artistID);
        this.isFavorite = true;
        gtag('event', 'favorite', {
          'artist': this.artist.id.toString() + ' ' + this.artist.name
        });
      }

      localStorage.setItem('favorites', JSON.stringify(favorites));
    },
    aboutMore() {
      this.aboutShowing = true;
    },
    findArtistsAtSameLocation() {
      let artistsAtSameLocation = [];
      this.artistsAtSameLocation.splice(0, this.artistsAtSameLocation.length);

      artistsAtSameLocation = this.$root.artists.filter(artist => {
        let addressMatches = artist.tour_address === this.artist.tour_address;
        return (addressMatches) && artist.id !== this.artist.id;
      });

      artistsAtSameLocation.forEach(relatedArtist => this.artistsAtSameLocation.push(relatedArtist));
    },
    openGallery(index) {
      this.$router.push({path: '/participants/' + this.artist.id + '/gallery', query: { index: index, artist: this.artist }});
    },
    openMap() {
      this.$root.openBrowser(`http://maps.google.com/?q=${this.artist.coordinates}`);
    },
    openADA() {
      this.$refs.ada.open();
    },
    setArtist(artists) {
      if (this.$route.query.preview) return;
      this.artist = artists.find(artist => {
        return artist.id == this.$route.params.id;
      });
    },
  },
  watch: {
    '$root.artists': 'setArtist',
  },
  mounted() {
    const getArtist = async () => {
      const response = await fetch(`${this.$root.api_url}getParticipants?year=${this.$root.year}&id=${this.$route.params.id}`);

      let data = await response.json();
      this.artist = data[0];
      setTimeout(() => {
        this.findArtistsAtSameLocation();
      }, 500);
    }

    if (this.$route.query.preview) {
      getArtist();
    } else {
      this.artist = this.$root.artists.find(artist => {
        return artist.id == this.$route.params.id;
      });
      this.isFavorite = localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')).includes(+this.$route.params.id) : false;
    }

    window.scrollTo(0, 0);
  },
};



// WEBPACK FOOTER //
// ./src/pages/Artist/Artist.js